import { NgModule } from '@angular/core';
import { MsSelectLanguageComponent } from './ms-select-language.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';
@NgModule({
	declarations: [MsSelectLanguageComponent],
	imports: [SharedLibsModule],
	exports: [MsSelectLanguageComponent],
	providers: [],
})
export class MsSelectLanguageModule {}
